<template>
  <div class="article-topics">
    <div class="small-container">
      <h5>Tópicos</h5>
      <a
        v-for="(topic, index) in topics"
        :key="topic.id"
        :href="`#topico-${index + 1}`"
      >
        {{ index + 1 }}. {{ topic.title }}
      </a>
    </div>
    <div
      v-for="(topic, index) in topics"
      :key="topic.id"
      class="small-container"
    >
      <h4 class="topic-title" :id="`topico-${index + 1}`">
        {{ index + 1 }}. {{ topic.title }}
      </h4>
      <div class="content" v-html="topic.description"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topics: Array
  }
};
</script>

<style lang="scss" scoped>
.article-topics {
  .topic-title {
    font-weight: 500;
    font-size: 32px;
    margin: 48px 0;
  }

  .content {
    margin: 48px 0;
  }

  a {
    font-family: "miller-text", serif;
    font-size: 20px;
    display: block;
  }
}
</style>
